import React from "react";
import { Provider } from "react-redux";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import store from "./store/store";
import { RouterApp } from "./config/router/RouterApp";

function App() {
  return (
    <div>
      <Provider store={store}>
        <RouterApp />
      </Provider>
    </div>
  );
}

export default App;
